/* eslint-disable no-unused-vars */
// **  cognito helper
import { CognitoAuth } from "@contexts/auth/cognito"

// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

import { userRoles } from "@constants/system"
// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

/** initla state for auth store  */
const initialState = {
  data: [],
  current: {},
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 5,
  currentPage: 1,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const refunds = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
    
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceRecord: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.status = payload.status
   
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: Number(payload),
        currentPage: 1 // Reset to first page when changing items per page
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.refunds],
        (refunds, refundsLoading) => {
          return refundsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.refunds],
        (refunds, refundsLoading) => refundsLoading.success
      )
    },
    /**
     *
     * @returns
     */
    paginationData() {
      return createSelector([slice], (refunds) => {
        let _data = [...refunds.data]
        
        // Apply status filter
        if (!isEmpty(refunds.filters) && refunds.filters.status) {
          const status = refunds.filters.status
          if (status.value !== "ALL") {
            _data = _data.filter((e) => e.status === status.value)
          }
        }
        
        // Apply keyword search
        if (!!refunds.keyword && refunds.keyword.trim() !== "") {
          const options = {
            keys: ["amount", "customer", "name", "phone"],
            threshold: 0.3
          }
          const fuse = new Fuse(_data, options)
          const searchResults = fuse.search(refunds.keyword)
          _data = searchResults.map((e) => e.item)
        }
        
        // Apply pagination
        const offset = (refunds.currentPage - 1) * refunds.itemPerPage
        _data = drop(_data, offset).slice(0, refunds.itemPerPage)

        return _data
      })
    },
    /**
     * Get total count of filtered/searched data
     * @returns
     */
    totalFilteredCount() {
      return createSelector([slice], (refunds) => {
        let _data = [...refunds.data]
        
        // Apply status filter
        if (!isEmpty(refunds.filters) && refunds.filters.status) {
          const status = refunds.filters.status
          if (status.value !== "ALL") {
            _data = _data.filter((e) => e.status === status.value)
          }
        }
        
        // Apply keyword search
        if (!!refunds.keyword && refunds.keyword.trim() !== "") {
          const options = {
            keys: ["amount", "customer", "name", "phone"],
            threshold: 0.3
          }
          const fuse = new Fuse(_data, options)
          const searchResults = fuse.search(refunds.keyword)
          _data = searchResults.map((e) => e.item)
        }
        
        return _data.length
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchRefunds() {
      appLogger.info("fetchRefunds", `[REDUX][${STORES.REFUNDS}]`)
      this.setAction(globalConst.action.FETCH_REFUNDS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "customersApiGateway",
          "/refunds"
        )
       
     
        this.setData(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
      this.setCurrentPage(1) // Reset to first page when filtering
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
      this.setCurrentPage(1) // Reset to first page when searching
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    },
    /**
     * Approve a refund request
     * This will approve the refund and deduct the amount from customer's reserved amount
     * @param {*} payload - { pk, sk }
     */
    async approveRefund(payload) {
      appLogger.info("approveRefund", `[REDUX][${STORES.REFUNDS}]`)
      this.setAction(globalConst.action.FETCH_REFUNDS) // Reuse action for loading state
      try {
        const result = await API.put(
          "adminsApi",
          `/req-refunds/v1/${payload.pk}/approve`,
          {
            body: {
              sk: payload.sk
            }
          }
        )

        if (result.success) {
          this.setMessage("Refund approved successfully")
          // Update the refund status in local state
          this.replaceRecord({
            pk: payload.pk,
            status: "VERIFIED"
          })
        } else {
          throw new Error(result.error || "Failed to approve refund")
        }

        this.setAction(globalConst.action.NONE)
        return result
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        throw new Error(error)
      }
    }
  })
}
